import { configureStore } from '@reduxjs/toolkit';
import activitiesReducer from './reducers/activities';
export const storeOptions = {
    reducer: {
        activities: activitiesReducer,
    },
};
const store = configureStore(storeOptions);
export default store;
